module.exports = __webpack_public_path__ + "img/txt.7ed0b898.svg";